import { ItemInput } from "./ItemInput";

export function TabContentItem({ item, category }) {
    return (<li className="meuselfstorage__tab__content__item"
                key={`${category.slug}_${item.id}`}>
        <img src={item.image}/>
        <span>{item.name}</span>
        <ItemInput item={item}/>
    </li>);
}